import { Usecase } from '@core/model/framework/usecase';
import type { AbortCaseServiceInput, ClerkService } from '@core/model/service/clerkService';
import { SERVICE_ID } from '@di/serviceId';
import { inject, injectable } from 'inversify';

export type AbortCaseInput = AbortCaseServiceInput;
export type AbortCaseOutput = void;

@injectable()
export class AbortCase implements Usecase<AbortCaseInput, AbortCaseOutput> {
  constructor(
    @inject(SERVICE_ID.clerkService)
    private readonly clerkService: ClerkService
  ) {}

  async execute(input: AbortCaseInput): Promise<AbortCaseOutput> {
    await this.clerkService.abortCase(input);
  }
}
